import { Row, Col, Modal, Skeleton, Badge, Image, Button } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import moment from "moment";
import notfound from "../../../assets/images/not_found.png";
import { PRICE } from "../../../constants/conts";

export const ViewAttribute = ({ show, hide, data }) => {

    const { request } = useRequest()
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState(data)
   
    

  

  
    return (
        <Modal open={show} width={800} title='Product Variant Detail' footer={[<Button className="edit-cls btnStyle primary_btn" onClick={() => hide()}>Ok</Button>]} onCancel={hide}>
            {loading ? [1,2,3,4].map(item => <Skeleton active key={item} />) : 
                <Row gutter={6}>
                    <Col span={12} xs={24} md={24}>
                        <div className="view-main-list">

                            <div className="view-inner-cls">
                                <h5>Name:</h5>
                                <h6><span className="cap">{list?.product_id?.name ? list?.product_id?.name : '-'}</span></h6>
                            </div>                        
                            <div className="view-inner-cls">
                                <h5>Price ({PRICE}):</h5>
                                <h6><span className="cap">{list.price ? list.price : '-'}</span></h6>
                            </div>
                            <div className="view-inner-cls">
                                <h5>number of benchmark :</h5>
                                <h6><span className="cap">{list.number_of_benchmark ? list.number_of_benchmark : '-'}</span></h6>
                            </div> 
                            <div className="view-inner-cls">
                                <h5>Number of inventory :</h5>
                                <h6><span className="cap">{list.number_of_inventory ? list.number_of_inventory : '-'}</span></h6>
                            </div> 
                            <div className="view-inner-cls">
                                <h5>Number of points :</h5>
                                <h6><span className="cap">{list.number_of_points ? list.number_of_points : '-'}</span></h6>
                            </div> 
                                                

                          

                            <div className="view-inner-cls">
                                <h5>Thumbnail:</h5>
                                <h6><Image width={60} src={list.thumbnail ? list.thumbnail : notfound} /></h6>
                            </div>

                            <div className="view-inner-cls">
                                <h5>Other Images:</h5>
                             
                                <div className="" style={{display:'flex', alignItems:"end",gap:"8px", justifyContent:"end", width:"100%"}}>
                                    {list && list.images && list.images.length > 0 ? list.images.map((item, index) => 
                                    <div className=""><Image width={60} height={40} src={item} /></div>
                                    ) : <div><Image width={60} height={40} src={notfound} /></div>}
                                </div>
                              
                            </div>

                            <div className="view-inner-cls">
                                <h5>Description:</h5>
                                <h6>{list?.product_id?.description ? <p dangerouslySetInnerHTML={{__html: list?.product_id?.description}}></p>   : "-"}</h6>
                            </div>

                          

                            <div className="view-inner-cls">
                                <h5>Status:</h5>
                                <h6>{list.is_active ? <Badge status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                            </div>

                        
                            <div className="view-inner-cls">
                                <h5>Attribute Combination:</h5>
                                <Row className="text-right">
                                <Col span={24}>
                                    {list && list.attribute && list.attribute.length > 0 && list.attribute.map((item, index) => 
                                    <h6 className="cap mt-1">{index+1}) {item.name} : {item.value} &nbsp;</h6>
                                    )}
                                </Col>
                                </Row>
                            </div>
                        

                            <div className="view-inner-cls">
                                <h5>Created On:</h5>
                                <h6>{list.created_at ? moment(list.created_at).format('DD-MMM-YYYY') : '-'}</h6>
                            </div>

                        </div>
                    </Col>
                </Row>
            }
        </Modal>
    )
}


